import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "26",
  height: "24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M12.18 12.844V2.63a.512.512 0 0 0-.514-.512c-1.802 0-3.577.444-5.166 1.29a10.96 10.96 0 0 0-3.948 3.567 10.923 10.923 0 0 0 2.142 14.528 10.98 10.98 0 0 0 10.13 2.035 10.974 10.974 0 0 0 4.576-2.717.513.513 0 0 0 0-.725l-7.22-7.252Zm-.51 10.132a9.955 9.955 0 0 1-6.944-2.811 9.902 9.902 0 0 1-.361-13.843 9.952 9.952 0 0 1 6.788-3.167v9.8a.56.56 0 0 0 0 .058v.047c0 .134.054.263.149.359l7 7.025a9.888 9.888 0 0 1-6.634 2.53",
  fill: "#757575"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M25.3 12.753a.512.512 0 0 0-.515-.506H14.33a.515.515 0 0 0-.514.515v.1c0 .134.055.263.15.359l7.37 7.398a.514.514 0 0 0 .724.003 10.87 10.87 0 0 0 3.238-7.768l.002-.101Zm-3.605 6.773-6.23-6.255h8.8a9.821 9.821 0 0 1-2.572 6.255M13.534 11.352h10.458a.515.515 0 0 0 .514-.518 10.928 10.928 0 0 0-3.25-7.667A10.984 10.984 0 0 0 13.535 0a.515.515 0 0 0-.513.513v10.326a.513.513 0 0 0 .514.513m.51-10.315a9.955 9.955 0 0 1 6.481 2.855 9.907 9.907 0 0 1 2.93 6.435h-9.411v-9.29Z",
  fill: "#757575"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
}
export default { render };